import { useQuery } from '@tanstack/react-query';
import { API } from '../../api';
import { useAuthContext } from '../../../assets/helpers/hooks';

type UseMeQueryParams = {
  enabled?: boolean;
}

export const useMeQuery = (params: UseMeQueryParams = {}) => {
  const { enabled = true } = params;
  const { setAuthData } = useAuthContext();

  const { data: meData, ...rest } = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const data = await API.common.me();
      if (data && localStorage.getItem('access_token')) {
        setAuthData(data);
      }
      return data;
    },
    enabled,
    retry: false,
    refetchInterval:false,
    refetchOnWindowFocus: false
  });

  return {
    meData,
    ...rest,
  };
};
